import { render, staticRenderFns } from "./ComplaintFollowUpInfo.vue?vue&type=template&id=9117d1da&"
import script from "./ComplaintFollowUpInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports